import { Pipe, PipeTransform } from "@angular/core";
import { DoctorService } from "src/app/services/doctor.service";
import { formatDabadocTime } from "src/app/helpers/dabadoc-time.helper";

/** "HH:mm" of a DabaDoc time, exactly as the API wrote it (no timezone conversion). */
@Pipe({
  standalone: true, name: "customTime" })
export class CustomTimePipe implements PipeTransform {
  locale: string = "fr";
  constructor(private doctorService: DoctorService) {}

  transform(date: any): any {
    if (this.doctorService.current) {
      this.locale = this.doctorService.current.locale;
    }
    return formatDabadocTime(date, "HH:mm", this.locale);
  }
}
